import React, {useState} from "react";
import { Button, Table, TableHeader, TableBody, TableRow, TableHeaderCell, TableCell, Input, Loader, Icon } from "semantic-ui-react";
import {useEffect} from "react";
import DartsPlayersCRUDForm from "./DartsPlayersCRUD.form";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";
import moment from "moment/moment";
import PhotoUploader from "./PhotoUploader/PhotoUploader";
import {getDartsPlayers, playersShowMode, playersEditMode, playersEditPhotoMode, setPageNumber, deleteDartsPlayer, changePageSize} from "./DartsPlayersCRUD.slice";
import './DartsPlayersCRUD.scss'
import {useAppDispatch, useAppSelector} from "../../../hooks/hooks";
import {setAdcQualifier} from "./helpers/setAdcQualifier";
import {showFullSizePhoto} from "./helpers/showFullSizePhoto";
import { buildQueryString } from "../../../helpers/buildQueryString";
import {useDebounce} from "../../../hooks/useDebounce";
import { api } from "../../../services/api/api.service";
import { API_PLAYERS_PHOTO } from "../../../services/api/api.urls";
import AppLoader from "../../../components/Loader/Loader";
import DimmerLoader from "../../../components/DimmerLoader/DimmerLoader";
import AppPagination from "../../../components/Pagination/AppPagination";
import InviteForm from "./components/InviteForm";

const DartsPlayersCRUD = () => {
    const {isVisibleForm, dartsPlayers, noContent, isEditPhotoMode, pagination, loadingPlayers} = useAppSelector(state => state.DartsPlayersCRUD);
    const cms = useAppSelector(state => state.Auth.cms);
    const clientFromState = useAppSelector(state => state.Auth.client);
    const dispatch = useAppDispatch();
    const [searchValue, setSearchValue] = useState("");
    const [sortField, setSortField] = useState("name");
    const [sortDirection, setSortDirection] = useState<'ascending' | 'descending'>('ascending');
    const [isShowPhotoWidget, setIsShowPhotoWidget] = useState(false)
    const [playerPhotoId, setPlayerPhotoId] = useState<number>(0)
    const [isExistPhoto, setIsExistPhoto] = useState('')
    const [photoWidgetLoader, setPhotoWidgetLoader] = useState(false);

    const [isShowInviteForm, setIsShowInviteForm] = useState(false);

    useEffect(() => {
        dispatch(getDartsPlayers(buildQueryString({ pageNum: pagination.activePage, pageSize: pagination.pageSize, sortField, sort: sortDirection === "ascending" ? 0 : 1 })))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSort = (field: string) => {
        const direction = sortField === field && sortDirection === 'ascending' ? 'descending' : 'ascending';
        setSortField(field);
        setSortDirection(direction);
        const payload = { pageNum: pagination.activePage, pageSize: pagination.pageSize, sortField, sort: direction === "ascending" ? 0 : 1 }
        dispatch(getDartsPlayers(buildQueryString(payload)))
    };

    const gotToPhotoWidget = async (id: number) => {
        try {
            setPhotoWidgetLoader(true)
            setPlayerPhotoId(id)
            const playersPhoto = await api.get(`${API_PLAYERS_PHOTO}/${id}`)
            setIsExistPhoto(playersPhoto.data)
            setPhotoWidgetLoader(false)
            setIsShowPhotoWidget(true)

        } catch (error) {
            setPhotoWidgetLoader(false)
        }
    }
    const onChangePager = (activePage: string | number | undefined) => {
        dispatch(setPageNumber(activePage))
        const params = { pageNum: activePage, pageSize: pagination.pageSize, search: searchValue}
        dispatch(getDartsPlayers(buildQueryString(params)));
    }

    const onSearch = () => {
        if (searchValue.trim().length < 3) return;
        dispatch(setPageNumber(1))
        dispatch(getDartsPlayers(buildQueryString({
            pageNum: 1,
            pageSize: pagination.pageSize,
            search:
            searchValue,
            sortField,
            sort: sortDirection === "ascending" ? 0 : 1
        })));
    };

    useDebounce(onSearch, searchValue, 500)

    const onChangePageSize = (value: any) => {
        dispatch(changePageSize(value))
        const params = { pageNum: pagination.activePage, pageSize: value, search: searchValue}
        dispatch(getDartsPlayers(buildQueryString(params)));
    }

    let isPrivate = clientFromState == null;

    return (
        <div className="cms-container-general">
            <div style={{display: "flex", justifyContent: "space-between"}}>
                <Input placeholder="Search....." value={searchValue} onChange={(e) => setSearchValue(e.target.value)} />
                {!isPrivate &&
                    <Button color="green" id="add_player" onClick={() => dispatch(playersShowMode())}>Add</Button>
                }
                {isPrivate &&
                    <Button color="green" id="invite_player" onClick={() => setIsShowInviteForm(true)}>Invite</Button>
                }
            </div>
            {loadingPlayers &&
                <DimmerLoader />
            }
            {!loadingPlayers &&
                <div className="cms-table-general">
                    <Table celled sortable striped textAlign="center">
                        <TableHeader>
                            <TableRow>
                                {cms['id'] &&
                                    <TableHeaderCell textAlign="center">Id</TableHeaderCell>
                                }
                                <TableHeaderCell onClick={() => onSort("name")} sorted={sortField === "name" ? sortDirection === "ascending" ? "ascending" : "descending" : undefined}>
                                    Name
                                </TableHeaderCell>
                                <TableHeaderCell onClick={() => onSort("surname")} sorted={sortField === "surname" ? sortDirection === "ascending" ? "ascending" : "descending" : undefined}>
                                    Surname
                                </TableHeaderCell>
                                <TableHeaderCell>Avatar</TableHeaderCell>
                                <TableHeaderCell>Nickname</TableHeaderCell>
                                <TableHeaderCell>Abbr</TableHeaderCell>
                                <TableHeaderCell>Gender</TableHeaderCell>
                                <TableHeaderCell>Displayname</TableHeaderCell>
                                <TableHeaderCell>Hometown</TableHeaderCell>
                                <TableHeaderCell>Nationality</TableHeaderCell>
                                <TableHeaderCell>Darts used</TableHeaderCell>
                                <TableHeaderCell>Career best</TableHeaderCell>
                                <TableHeaderCell>Throw hand</TableHeaderCell>
                                <TableHeaderCell>Date of birth</TableHeaderCell>
                                <TableHeaderCell>ADC Qualifier</TableHeaderCell>
                                {cms['delete'] && 
                                    <TableHeaderCell></TableHeaderCell>
                                }
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {dartsPlayers?.map((player) => {
                                return (
                                    <TableRow key={player.id}>
                                        {cms['id'] &&
                                            <TableCell>{player.id}</TableCell>
                                        }
                                        <TableCell>{player.name}</TableCell>
                                        <TableCell>{player.surname}</TableCell>
                                        <TableCell><img alt='players-avatar' className='players-table-avatar'src={`data:image/png;base64,${player.avatar}`}
                                            onClick={() => showFullSizePhoto({ id: player.id, setIsExistPhoto, dispatch })} />
                                        </TableCell>
                                        <TableCell>{player.nickname}</TableCell>
                                        <TableCell>{player.abbr.slice(0, 3)}</TableCell>
                                        <TableCell>{player.gender}</TableCell>
                                        <TableCell>{player.displayname}</TableCell>
                                        <TableCell>{player.hometown}</TableCell>
                                        <TableCell>{player.nationality}</TableCell>
                                        <TableCell>{player.dartsUsed}</TableCell>
                                        <TableCell>{player.careerBest}</TableCell>
                                        <TableCell>{player.throwHand}</TableCell>
                                        <TableCell>{moment(player.dateOfBirth).format("YYYY-MM-DD")}</TableCell>
                                        <TableCell>{setAdcQualifier(player.adcQualifier)}</TableCell>
                                        {cms['delete'] &&
                                            <TableCell>
                                                <div className={"players-table-controls"}>
                                                    <DeleteModal id={player.id} titleModal={"Delete your Player"} confirmText="Are you sure you want to delete your player?"
                                                        deleteAction={() => dispatch(deleteDartsPlayer(player.id))} />
                                                    <Icon name='pencil alternate' link color="grey" size="small" onClick={() => dispatch(playersEditMode(player.id))} />
                                                    {!photoWidgetLoader &&
                                                        <Icon name='photo' link color='blue' size="small" onClick={() => gotToPhotoWidget(player.id)} />
                                                    }
                                                    {photoWidgetLoader && player.id === playerPhotoId &&
                                                        <AppLoader/>
                                                    }
                                                </div>
                                                {isEditPhotoMode &&
                                                    <div className="photo-uploader__show-full-size">
                                                        <div
                                                            onClick={() => dispatch(playersEditPhotoMode(false))}
                                                            className="photo-uploader__show-full-size-close"
                                                        />
                                                        {isExistPhoto
                                                            ? <img src={`data:image/png;base64,${isExistPhoto}`} alt="player" />
                                                            : <Loader active />
                                                        }
                                                    </div>
                                                }
                                            </TableCell>
                                        }
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </div>}
            {noContent &&
                <div className="schedule-info-block">No players</div>
            }
            <AppPagination props={pagination} onChangePager={onChangePager} onChangePageSize={onChangePageSize} />
            {isVisibleForm &&
                <DartsPlayersCRUDForm />
            }
            {isShowInviteForm &&
                <InviteForm closeForm={() => setIsShowInviteForm(false)} />
            }
            {isShowPhotoWidget &&
                <PhotoUploader isPlayerPhoto={isExistPhoto} playerId={playerPhotoId} closeUploaderHandler={setIsShowPhotoWidget} />
            }
        </div>
    );
};

export default DartsPlayersCRUD;
